import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useOnClickOutside } from '../../utils';
import MoreActions from '../../components/icons/MoreActions';
import editImg from '../../assets/images/edit.svg';
import deleteImg from '../../assets/images/delete.svg';

import { selectProject } from '../../actions/project';

const ProjectCell = ({
  project,
  activeProject,
  setShowProjectList,
  setShowEditProjectModal,
  setShowDeleteProjectModal,
  setSelected,
}) => {
  const ref = useRef();
  const exceptional = useRef();
  const dispatch = useDispatch();
  const [showActions, setShowActions] = useState(false);

  useOnClickOutside(ref, () => setShowActions(false), exceptional);

  const handleProjectClick = () => {
    dispatch(selectProject(project));
    setShowProjectList(false);
  };

  const handleShowEditModal = () => {
    setSelected(project);
    setShowActions(false);
    setShowEditProjectModal(true);
    setShowProjectList(false);
  };

  const handleShowDeleteModal = () => {
    setSelected(project);
    setShowActions(false);
    setShowDeleteProjectModal(true);
    setShowProjectList(false);
  };

  return (
    <div className="project-item">
      <div className="project-item-inner">
        <div className="main-section">
          <div
            className={`checkbox ${project.id === activeProject.id ? 'selected' : ''}`}
            onClick={handleProjectClick}
          >
            <div className={project.id === activeProject.id ? 'checked' : ''}></div>
          </div>
          <p className={project.id === activeProject.id ? 'active' : ''}>{project.name}</p>
        </div>
        <div
          className="more-actions"
          onClick={() => setShowActions(!showActions)}
          ref={exceptional}
        >
          <MoreActions color={showActions ? '#01244E' : '#B8C0CC'} />
        </div>
      </div>
      {showActions && (
        <div className="actions" ref={ref}>
          <div className="action-item" onClick={() => handleShowEditModal()}>
            <img src={editImg} alt="edit" />
            <span>Edit Project</span>
          </div>
          <div className="action-item" onClick={() => handleShowDeleteModal()}>
            <img src={deleteImg} alt="delete" />
            <span>Delete Project</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectCell;
